import { FC } from 'react';

import ReactModal from 'react-modal';

import { Container, IconClose } from './styles';

interface ModalProps {
  isOpen: boolean;
  setOpen: (statusModalVisible: boolean) => void;
  maxWidth?: string;
  maxHeight?: string;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  setOpen,
  children,
  maxHeight,
  maxWidth,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      onRequestClose={() => setOpen(false)}
      ariaHideApp={false}
      style={{
        content: {
          overflow: 'visible',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          background: '#FFFEFC',
          color: '#000000',
          borderRadius: '0.8rem',
          maxWidth: maxWidth || '62.1rem',
          width: '100%',
          maxHeight: maxHeight || '41.5rem',
          height: '100%',
          // border: 'none',
          animation: 'bounceIn 1s ease-in-out',
          boxShadow: '#0000000F 0px 0.3rem 0.6rem',
          padding: 0,
        },
        overlay: {
          background: '#232323aa',
          zIndex: 99,
        },
      }}
    >
      <Container>
        <IconClose size={30} onClick={() => setOpen(false)} />
        {children}
      </Container>
    </ReactModal>
  );
};

export default Modal;
